import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MyStepper from '../../../../components/Stepper';
import AssetForm from './assetForm';
import LiabilityForm from './liabilityForm';
import StructureForm from './structureForm';
import { steps1, steps } from '../../../../utility/data';
import { IoMdArrowBack } from 'react-icons/io';
import { addAsset } from '../../../../services/addWealth/assetApi';
import { Toast } from 'primereact/toast';
import { addStructure } from '../../../../services/addWealth/structureApi';
import { addLiablity } from '../../../../services/addWealth/liability';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getUserAssets } from '../../../../services/transaction';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGroups, resetGroupsState } from '../../../../redux/slices/groupsSlice';
import { clearSelectedAsset, fetchUserAssets } from '../../../../redux/slices/userAssetsSlice';
const Home = () => {
  const heading = 'What would you like to create today ?';
  const AssetsHeading = 'Select the type of asset you want to add';

  const [currentStepGroup, setCurrentStepGroup] = useState(1);
  const [currentStep, setCurrentStep] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [selectedAssetType, setSelectedAssetType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clickedStep, setClickedStep] = useState(null);

  const accessToken = JSON.parse(localStorage.getItem('access_token'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);
  const { groupsData, groupLoading } = useSelector((state) => state.groups);
  const userAssets = useSelector((state) => state.userAssets.data);

  const handleBackClick = () => {
    if (showForm) {
      setShowForm(false);
    } else if (currentStepGroup === 2) {
      setCurrentStepGroup(1);
      setCurrentStep(0);
    }
  };

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchGroups(accessToken));
      dispatch(fetchUserAssets({ assetTypeId: 1 }));
    }
    return () => {
      dispatch(resetGroupsState());
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, accessToken]);

  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <AssetForm assetType={selectedAssetType} onSubmit={handleAssetSubmit} loading={loading} setLoading={setLoading} groupsData={groupsData} userAssets={userAssets} />;
      case 1:
        return <LiabilityForm onSubmit={handleLiabilitySubmit} loading={loading} groupsData={groupsData} />;
      case 2:
        return <StructureForm onSubmit={handleStructureSubmit} loading={loading} groupsData={groupsData} />;
      default:
        return null;
    }
  };

  const handleStepSelection = (index, step) => {
    setClickedStep(step?.name);
    if (currentStepGroup === 1) {
      if (index === 0) {
        setCurrentStepGroup(2);
        setCurrentStep(0);
      } else {
        setCurrentStep(index);
        setShowForm(true);
      }
    } else if (currentStepGroup === 2) {
      setSelectedAssetType(steps1[index]);
      setShowForm(true);
    }
  };

  const handleAssetSubmit = async (assetData, assetTypeName) => {

    setLoading(true);
    const formattedData = {
      ...assetData,
      initialBalance: assetData.initialBalance ? assetData.initialBalance.replace(/[,']/g, '') : '',
      costPrice: assetData.costPrice ? assetData.costPrice.replace(/[,']/g, '') : '',
      date: assetData?.date
        ? new Date(assetData?.date).toLocaleDateString('en-CA')
        : null,
      multiples: assetData?.multiples ? assetData?.multiples.replace(/[,']/g, '') : '',
      ebitda: assetData?.ebitda ? assetData?.ebitda.replace(/[,']/g, '') : '',
    };
    try {
      const response = await addAsset(formattedData, assetTypeName, accessToken);
      if (response.data.status === true) {
        toast.current.show({
          className: 'bg-green-300 text-white',
          severity: 'success',
          summary: 'Success',
          detail: response.data.message,
          life: 3000,
        });
        
        setTimeout(() => {
          const formattedOption = typeof assetTypeName === 'string'
            ? assetTypeName.toLowerCase().split(' ').join('-')
            : 'unknown-option';
          navigate(`/view-${formattedOption}-transaction`, {
            state: {
              id: response?.data?.data ?? null,
            },
          });
        }, 1000);
      }
    } catch (error) {
      console.error('Error adding asset:', error);
      toast.current.show({ className: 'bg-yellow-700 text-white', severity: 'warn', summary: 'Warning', detail: error.message, life: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const handleStructureSubmit = async (structureData) => {
    setLoading(true);
    try {
      const response = await addStructure(structureData, accessToken);
      if (response.data.status === true) {
        toast.current.show({ className: 'bg-green-300 text-white', severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    } catch (error) {
      console.error('Error adding structure:', error);
      toast.current.show({ className: 'bg-yellow-700 text-white', severity: 'warn', summary: 'Warning', detail: error.message, life: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const handleLiabilitySubmit = async (liabilityData) => {
    setLoading(true);
    try {
      const response = await addLiablity(liabilityData, accessToken);
      if (response.data.status === true) {
        toast.current.show({ className: 'bg-green-300 text-white', severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    } catch (error) {
      console.error('Error adding liability:', error);
      toast.current.show({ className: 'bg-yellow-700 text-white', severity: 'warn', summary: 'Warning', detail: error.message, life: 3000 });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Toast ref={toast} />
      <div className={`fixed top-24 left-8 ${currentStepGroup !== 1 || showForm ? 'block' : 'hidden'}`}>
        <button onClick={handleBackClick}>
          <IoMdArrowBack size={24} />
        </button>
      </div>

      {!showForm ? (
        <div className="flex justify-center items-center h-full p-2">
          <div className="text-2xl flex justify-center flex-col items-center gap-6">

            <MyStepper
              steps={currentStepGroup === 1 ? steps : currentStepGroup === 2 ? steps1 : ''}
              heading={currentStepGroup === 2 ? AssetsHeading : heading}
              onStepSelect={handleStepSelection}
              currentStepGroup={currentStepGroup}
              currentStep={currentStep}
              selectedType={selectedAssetType ? selectedAssetType : ''}
            />
          </div>
        </div>
      ) : (
        <div className="w-full p-8 rounded-lg px-16">
          {loading ? (
            <div className="flex justify-center items-center fixed inset-0">
              <ProgressSpinner />
            </div>
          ) : (
            renderForm()
          )}
        </div>
      )}
    </>
  );
};

export default Home;